import { render, staticRenderFns } from "./addService.vue?vue&type=template&id=94675dde&scoped=true&"
import script from "./addService.vue?vue&type=script&lang=js&"
export * from "./addService.vue?vue&type=script&lang=js&"
import style0 from "./addService.vue?vue&type=style&index=0&id=94675dde&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94675dde",
  null
  
)

export default component.exports